import { render, staticRenderFns } from "./CompContents.vue?vue&type=template&id=90585ef8"
import script from "./CompContents.vue?vue&type=script&setup=true&lang=js"
export * from "./CompContents.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports